<template>
  <div class="modal fade show custom-modal modal-show" id="myModalAccept" role="dialog" v-if="showStatusPinModal">
    <div class="modal-dialog modal-dialog-centered model-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="closeModal()">&times;</button>
        </div>
        <div class="modal-body text-center pb-0">
          <img src="@/../src/assets/images/group-10.png" alt="search" class="img-responsive mb-3">
          <p class="mb-0 pre-insp">Pre-Inspection Number</p>
          <p class="pinNumber mb-0">{{pinNumber}}</p>
          <p class="success" v-if="updatePinStatusResponse.status=='72'">has been successfully accepted</p>
          <p class="success" v-else>has been Rejected</p>
        </div>
        <div class="col-12 modal-footer pb-4">
          <button type="button" class="btn bgc-btn-primary" @click="closeModal()">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "@vue/composition-api";
export default {
  name: "AcceptModal",
  props:['pinNumber', 'showStatusPinModal',"updatePinStatusResponse"],
  setup(props, context){
    let state = reactive({
    });
    function closeModal(){
      context.parent.closeAcceptModal();
    }
    return {
      state,
      closeModal
    }
  }
};
</script>

<style scoped>
.modal-show {
  display: block;
  transform: scaleY(0) scaleX(0);
  animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
.modal-body {
  overflow-y: hidden;
}
.pinNumber {
  color: #0070be;
  font-size: 20px;
  font-weight: bold;
  margin-top: -5px;
}
.pre-insp {
  color: #666666;
}
.success {
  color: #666666;
  margin-top: -5px;
}
.modal-footer {
  justify-content: center;
  border-top: 0 none;
}
</style>